/**
 * /en/admin/structure/paragraphs_type/datepicker_labels/fields
 */

import Paragraph from "@js/core/paragraph.es6.js";
import SlotUnavailableModalParagraph from "@js/paragraphs/slot-unavailable-modal-paragraph.es6.js";

export default class DatepickerLabelsParagraph extends Paragraph {
  constructor({ parentElement }) {
    super({
      machineName: 'datepicker_labels',
      parentElement,
    });
  }

  get slotUnavailableModalParagraph() {
    return new SlotUnavailableModalParagraph({
      machineName: 'field_slot_unavailable_modal',
      parentElement: this,
    });
  }
}
